import { useAuthenticator } from '@aws-amplify/ui-react';
import { LoadingIndicator } from 'components';
import SplashScreen from 'components/Splash/Splash';
import React, { Suspense } from 'react';
import { Redirect } from 'react-router-dom';

export const PublicRoute = ({ component: Component, ...rest }: any) => {
  const { authStatus } = useAuthenticator(context => [context.authStatus]);

  if (authStatus === 'configuring') return <SplashScreen />;

  if (authStatus === 'authenticated') {
    return <Redirect to={{ pathname: '/call-to-action' }} />;
  }

  return (
    <Suspense fallback={<LoadingIndicator visible />}>
      <Component {...rest} />
    </Suspense>
  );
};
